import { render, staticRenderFns } from "./ArticleTemplate.vue?vue&type=template&id=22cf5691&scoped=true&"
import script from "./ArticleTemplate.vue?vue&type=script&lang=ts&"
export * from "./ArticleTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTemplate.vue?vue&type=style&index=0&id=22cf5691&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf5691",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VHover,VImg})
